import API from "../../api/api";
import { getUserDetails } from "../../api/api-quatro";

const $API = new API();
const UserProfile = {
  state: () => ({
    user: {}
  }),
  mutations: {
    UPDATE_USER_PROFILE(state, fields) {
      state.user = { ...state.user, ...fields };
    }
  },
  actions: {
    async GET_USER_PROFILE({ commit, state, rootGetters }) {
      if (Object.keys(state.user).length !== 0) {
        const user = JSON.parse(JSON.stringify(state.user));
        return user;
      }

      let activeDoctor = rootGetters.activeDoctor;
      if (!activeDoctor) {
        const res = await $API.getUserInfo();
        activeDoctor = res.message.doctors[0] || null;
      }

      // activeDoctor.license = "30382"; /// Temporal

      const user = await getUserDetails(activeDoctor.license);
      user.license = activeDoctor.license;
      commit("UPDATE_USER_PROFILE", user);
      return user;
    }
  }
};

export default UserProfile;
